<main class="text-start">
    <h1 class="page-title"> {{ 'users_management.list.title' | translate }} </h1>

    <div class="w-full bg-[#F6F6F6] rounded-lg p-3.5">
        <div class="flex justify-between items-start">
            <div class="border border-[#e0e0e0] w-52 sm:w-72 rounded-lg overflow-hidden flex">
                <span class="bg-white py-[7.5px] ps-2.5">
                    <i class="bi bi-search text-sm"></i>
                </span>
                <input type="text"
                    class="bg-white py-[8px] px-4 w-full text-start focus:outline-none focus:border-black text-xs"
                    [placeholder]="'users_management.list.search_placeholder' | translate" (input)="onSearchChange($event)">
            </div>
            <div class="flex">
                <button *ngIf="isOwner"
                    [routerLink]="['/users/new']"
                    class="bg-[#611F79] text-white px-3.5 h-8 rounded-lg text-xs inline-flex items-center cursor-pointer">
                    <i class="bi bi-person-plus-fill me-2 text-xs"></i> {{ 'users_management.list.add_button' | translate }}
                </button>
            </div>
        </div>

        <div class="w-full bg-white rounded-xl px-5 py-5 mt-3">
            <div class="overflow-x-auto">
                <table class="generic-table text-nowrap">
                    <thead>
                        <tr>
                            <th>{{ 'users_management.list.table.name' | translate }}</th>
                            <th>{{ 'users_management.list.table.status' | translate }}</th>
                            <th>{{ 'users_management.list.table.phone' | translate }}</th>
                            <th>{{ 'users_management.list.table.email' | translate }}</th>
                            <th>{{ 'users_management.list.table.date_joined' | translate }}</th>
                            <th>{{ 'users_management.list.table.action' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="!vendorStaff">
                            <tr *ngFor="let _ of [1,2,3,4,5]" app-table-skeleton-row [columns]="6"></tr>
                        </ng-container>
                        <tr *ngFor="let staff of vendorStaff" [routerLink]="['/users', staff.id]" class="cursor-pointer">
                            <td>
                                <div class="flex justify-start items-center gap-2">
                                    <div class="bg-[#FCC5F3] w-6 h-6 rounded-full overflow-hidden">
                                        <img [src]="staff.user.profile_image || 'dashboard/place-holders/avatar-female.png'"
                                            class="w-6 h-6 rounded-full object-cover" alt="">
                                    </div>
                                    <span>{{ staff.user.name }}</span>
                                </div>
                            </td>
                            <td>
                                <span [ngClass]="{
                                        'bg-red-100 text-red-700': staff.user.is_active == false,
                                        'bg-green-100 text-green-700': staff.user.is_active == true
                                        }" class="status-chip">
                                    {{ (staff.user.is_active ? 'users_management.list.status.active' : 'users_management.list.status.inactive') | translate }}
                                </span>
                            </td>
                            <td>{{ staff.user.phone_number ?? '---' }}</td>
                            <td>{{ staff.user.email }}</td>
                            <td>{{ staff.user.date_joined | date:'medium' }}</td>
                            <td (click)="$event.stopPropagation()">
                                <div *ngIf="isOwner; else viewOnly">
                                    <button
                                        class="border border-[#E5E7EB] px-3.5 py-1.5 text-[0.7rem] rounded-md cursor-pointer"
                                        [routerLink]="['/users', staff.id, 'edit']">{{ 'users_management.list.actions.edit' | translate }}</button>
                                </div>
                                <ng-template #viewOnly>
                                    <button
                                        class="border border-[#E5E7EB] px-3.5 py-1.5 text-[0.7rem] rounded-md cursor-pointer"
                                        [routerLink]="['/users', staff.id]">{{ 'users_management.list.actions.view' | translate }}</button>
                                </ng-template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</main>
